import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { mainNavigationStyles } from "@insite/content-library/Widgets/Header/MainNavigation";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    mainMenuWrapper?: InjectableCss;
    searchWrapper?: InjectableCss;
    loginWrapper?: InjectableCss;
    cartWrapper?: InjectableCss;
}

logoStyles.wrapper = {
    css: css`
        max-width: 100%;
        max-height: 110px;
        padding-top: 7px;
    `,
};

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-direction: column;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    logoWrapper: {
        css: css`
            text-align: center;
            padding: 0;
            width: 15%;
            a {
                height: 78px;
                width: 125px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                width: 97px;
                                height: 65px;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            background: #fff;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    searchMenuWrapper: {
        css: css`
            display: flex;
            padding: 18px 15px 18px 0;
            width: 85%;
            background-color: #18243d;
            align-items: center;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            padding: 15px;
                        `,
                        css`
                            padding: 10px;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    mainMenuWrapper: {
        css: css`
            width: 35%;
            button[data-test-selector="expandMobileMenu"] {
                position: absolute;
                top: 10px;
                background: transparent;
                border: none;
                left: 15px;
                padding: 0;
                span {
                    color: #18243d;
                    svg {
                        width: 28px;
                        height: 28px;
                    }
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 0px !important;
                        `,
                        css`
                            width: 49%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    searchWrapper: {
        css: css`
            width: 40%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100% !important;
                        `,
                        css`
                            width: 28%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    loginWrapper: {
        css: css`
            width: 15%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: none;
                        `,
                        css`
                            width: 17%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    cartWrapper: {
        css: css`
            min-width: 10%;
            a[data-test-selector="cartLink"] {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                position: absolute;
                                top: 20px;
                                right: 15px;
                                span {
                                    color: #18243d;
                                    margin: 0;
                                }
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 0px !important;
                            min-width: 0;
                        `,
                        css`
                            width: 13%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.container}>
        <StyledWrapper className="logoSection" {...logoLinksSearchStyles.logoWrapper}>
            <Zone contentId={id} zoneName="Logo" />
        </StyledWrapper>
        <StyledWrapper className="searchSection" {...logoLinksSearchStyles.searchMenuWrapper}>
            <StyledWrapper {...logoLinksSearchStyles.mainMenuWrapper}>
                <Zone contentId={id} zoneName="MainNav" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.searchWrapper}>
                <Zone contentId={id} zoneName="Search" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.loginWrapper}>
                <Zone contentId={id} zoneName="Login" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.cartWrapper}>
                <Zone contentId={id} zoneName="Cart" />
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
